// extracted by mini-css-extract-plugin
export default {"meta":"PostMeta_meta__BMekD","category":"PostMeta_category__O0VrB","authorDate":"PostMeta_authorDate__j9rSl","author":"PostMeta_author__4vBCF","date":"PostMeta_date__AmDlD"};